import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ChartIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1 2.36526C1 1.81298 1.44772 1.36526 2 1.36526H14C14.5523 1.36526 15 1.81298 15 2.36526V10.3653C15 10.9176 14.5523 11.3653 14 11.3653H2C1.44772 11.3653 1 10.9176 1 10.3653V2.36526ZM10.9656 3.36526C10.6092 3.36526 10.4308 3.79612 10.6827 4.04811L10.9696 4.33494L9.08285 6.22166C8.99488 6.30963 8.85561 6.31953 8.75608 6.24488L8.08747 5.74343C7.43463 5.2538 6.53004 5.28039 5.90707 5.80751L3.26546 8.04273C2.94925 8.31029 2.90982 8.78351 3.17737 9.09972C3.44493 9.41592 3.91816 9.45537 4.23437 9.18781L6.87599 6.95258C6.96498 6.87728 7.09421 6.87348 7.18747 6.94343L7.85608 7.44488C8.55279 7.96742 9.5277 7.89813 10.1435 7.28232L12.0302 5.39561L12.3171 5.68243C12.569 5.93441 12.9999 5.75594 12.9999 5.39957V3.76526C12.9999 3.54435 12.8208 3.36526 12.5999 3.36526H10.9656Z"
		/>
		<path
			fill="currentColor"
			d="M7 12.3653V13.9507C6.4174 14.1566 6 14.7122 6 15.3653H10C10 14.7122 9.5826 14.1566 9 13.9507V12.3653H7Z"
		/>
	</svg>
))
